import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import { aboutme } from "../assets";
// import resumePdf from "../assets/resume.pdf";

const AboutMe = () => {
  return (
    <div>
      <NavBar />
      <div className="mt-11 ">
        <section className="bg-white dark:bg-gray-900">
          <div className="container mx-auto px-4 py-8 lg:py-16">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
              <div className="lg:col-span-7 flex flex-col justify-center items-center">
                <h1 className=" text-4xl md:text-5xl xl:text-6xl font-mono font-extrabold text-center  lg:text-left mt-4 lg:mb-0 dark:text-white mx-18  ">
                  Eze Adiele
                </h1>
                <p className="  text-base md:text-lg lg:text-xl font-light  dark:text-gray-400">
                  My Name is Eze Adiele and I am a seasoned Information
                  Technology professional with over a decade of experience
                  specializing in designing and maintaining resilient
                  architectures for clients.
                  <br />
                  Over the past five years, I have been dedicated to helping
                  companies implement and optimize their IT infrastructures,
                  leading to a measurable 30% increase in profitability.
                  <br /> My core strength lies in my ability to deeply
                  understand clients' unique needs and leverage a comprehensive
                  skill set along with the appropriate toolchain to deliver
                  tailored, scalable solutions. I am committed to excellence,
                  bringing a strategic approach to architecture design that
                  ensures both performance and long-term sustainability. <br />I
                  take pride in my dedication, commitment, and results-driven
                  mindset and I am seeking an opportunity with a
                  forward-thinking organization where I can contribute
                  long-term, not just as a resource but as a valued team member,
                  driving innovation and delivering a positive return on
                  investment within a strong, collaborative company culture.
                </p>
              </div>
              <div className="lg:col-span-5 flex justify-center lg:justify-end mt-11">
                <img
                  src={aboutme}
                  alt="mockup"
                  className=" card-zoom-image rounded-lg lg:hover:scale-110 transition duration-300"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default AboutMe;
